export default __webpack_public_path__ + "static/media/grid2.5409686f.jpg";